import { createSelector } from 'reselect';

export const retrieveSubscriptionSelector = (state) =>
  state?.ascendon?.subscriberAPI?.RetrieveSubscription;

export const subscriptionTypeSelector = createSelector(
  retrieveSubscriptionSelector,
  (retrieveSubscription) => {
    const [subscriptionType] = retrieveSubscription?.Subscription.Items.map(
      (item) =>
        item.PricingPlan.SubscriptionBillingCycle === 2 ? 'Monthly' : 'Annual',
    );

    return subscriptionType;
  },
);

export const subscriptionPackageSelector = createSelector(
  retrieveSubscriptionSelector,
  (retrieveSubscription) => {
    const [subscriptionPackage] = retrieveSubscription?.Subscription.Items.map(
      (item) => item.Product.Name,
    );
    return subscriptionPackage;
  },
);
